"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const endpoints_1 = require("./endpoints");
const firebaseWeb_1 = require("./firebaseWeb");
const store_1 = require("./store");
exports.defaultConfig = {
    store: store_1.store,
    endpoints: endpoints_1.endpoints,
    firebaseWeb: firebaseWeb_1.firebaseWeb,
    attachments: {
        maxFileSize: 104857600,
    },
};
//# sourceMappingURL=default.js.map